/** @jsxImportSource theme-ui */
import styled from '@emotion/styled';

export const CanvasStyled = styled('canvas')`
    border: 1px solid #0E0E2C;
    width: 100%;
    height: 188px;
    border-radius: 10px;
`;
